<template>
<div id="auditoria_fraccion_periodos" >
  <div>
    <v-breadcrumbs :items="breadcrumbs" >
      <v-icon slot="divider" >forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12" >
        <base-material-card color="primary" icon="library_books" title="AUDITORÍA PERIODO DE FRACCIONES" class="elevation-1 px-5 py-3" >
          <br>
          <v-tabs grow style="margin-bottom: 30px;" >
            <v-tabs-slider color="primary" ></v-tabs-slider>
              <v-tab :key="'in-view'" >Periodos de Fracciones</v-tab>
            <v-tab :key="'in-report'" >Fracciones con Saldo Pendiente</v-tab>

            <v-tab-item :key="'in-view'" >
               <v-card-text>
                  <v-card-title>
                    <span class="headline" ></span>
                  </v-card-title>
                  <v-form ref="form" lazy-validation>
                    <v-container grid-list-md text-xs-center>
                      <v-row row wrap>
                        <v-col sm="12" md="6" lg="6">
                          <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }">
                              <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'"
                                :rules="[rules.required, validaAnio, validaFecha]"></v-text-field>
                            </template>

                            <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false">
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu1 = false">
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col sm="12" md="6" lg="6">
                          <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }">
                              <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'"
                                :rules="[rules.required, validaAnio, validaFecha]"></v-text-field>
                            </template>
                            <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false">
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu2 = false">
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>

                        </v-col>
                      </v-row>

                      <v-row no-row wrap>
                        <v-col cols="12" sm="12" lg="3">
                          <v-autocomplete v-model="tipo_reporte" :items="tipos" :hide-no-data="true" :return-object="false" label="Tipo de Filtro" item-value="id" @change="model.fraccion = []; model.palabras = [];"/>
                        </v-col>

                        <v-col cols="12" sm="4" lg="6" v-if="tipo_reporte == 1">
                          <v-autocomplete v-model="model.fraccion" :items="fracciones" :hide-no-data="true" :return-object="false" label="Seleccione una Fracción" multiple small-chips deletable-chips :rules="[validaFracciones]" @change="validaFracciones">
                            <template slot="message">
                              <div style="margin-top:15px">

                              </div>
                            </template>
                          </v-autocomplete>
                          <br>
                          <div class="red--text" style="margin-top:-10px">
                            *Máximo 5 Fracciones
                          </div>
                        </v-col>

                        <v-col cols="12" sm="4" lg="6" v-if="tipo_reporte == 2">
                          <v-text-field v-model="model.fraccion" label="Fracciones" prepend-icon="fa-search"
                            :rules="[rules.required]" disabled></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" lg="3" v-if="tipo_reporte == 2">
                          <v-btn icon title="Pegar Listado" @click="listado=''; dialog1 = !dialog1; model.fraccion = [];" v-tippy>
                            <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                          </v-btn>
                        </v-col>

                        <v-col cols="12" sm="4" lg="6" v-if="tipo_reporte == 3">
                          <v-text-field v-model="model.palabras" label="Palabras Clave" prepend-icon="fa-search"
                            :rules="[rules.required]" disabled></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" lg="3" v-if="tipo_reporte == 3">
                          <v-btn icon title="Pegar Listado" @click="listado=''; dialog2 = !dialog2; model.palabras = []" v-tippy>
                            <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                          </v-btn>
                        </v-col>

                      </v-row>

                    </v-container>

                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <exportar-excel v-if="consultado1" :data="datafiltered1" :name="'PeriodosFracciones.xlsx'" :exportFields="campos_excel_periodos">
                      <v-btn dark color="success" title="Exportar Registros" v-tippy @click="filtrar_data_periodos">
                          <v-icon dark>get_app</v-icon>Excel
                      </v-btn>
                  </exportar-excel>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="generar_consulta">
                    <v-icon>done</v-icon>Vista Previa
                  </v-btn>
                </v-card-actions>
                <v-card-text>
                  <v-client-table ref="vuetable_periodos" :data="datos" :columns="columns" :options="options" class="elevation-1 pa-2" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontró ningun registro</v-alert>
                    </template>
                  </v-client-table>
                </v-card-text>
            </v-tab-item>

            <v-tab-item :key="'in-report'" >
               <v-card-text>
                  <v-card-title>
                    <span class="headline" ></span>
                  </v-card-title>
                  <v-form ref="form2" lazy-validation>
                    <v-container grid-list-md text-xs-center>
                      <v-row row wrap>
                        <v-col sm="12" md="6" lg="6">
                          <v-menu offset-x ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }">
                              <v-text-field v-on="on" v-model="model2.fecha_cargo" label="Fecha Cargo" color="secondary" prepend-icon="event" @blur="model2.fecha_cargo = parseDate(model2.fecha_cargo)" v-mask="'####-##-##'"
                                :rules="[rules.required, validaAnio, validaFecha]"></v-text-field>
                            </template>

                            <v-date-picker v-model="model2.fecha_cargo" color="secondary" scrollable locale="es-mx" @input="menu3 = false">
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu3 = false">
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col sm="12" md="6" lg="6">
                          <v-menu offset-x ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }">
                              <v-text-field v-on="on" v-model="model2.fecha_abono" label="Fecha Abono" color="secondary" prepend-icon="event" @blur="model2.fecha_abono= parseDate(model2.fecha_abono)" v-mask="'####-##-##'"
                                :rules="[rules.required, validaAnio, validaFecha]"></v-text-field>
                            </template>
                            <v-date-picker v-model="model2.fecha_abono" color="secondary" scrollable locale="es-mx" @input="menu4 = false">
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu4 = false">
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>

                        </v-col>
                      </v-row>
                    </v-container>

                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <exportar-excel v-if="consultado2" :data="datafiltered2" :name="'SaldosFracciones.xlsx'" :exportFields="campos_excel_saldos">
                      <v-btn dark color="success" title="Exportar Registros" v-tippy @click="filtrar_data_saldos">
                          <v-icon dark>get_app</v-icon>Excel
                      </v-btn>
                  </exportar-excel>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="generar_consulta_saldos">
                    <v-icon>done</v-icon>Vista Previa
                  </v-btn>
                </v-card-actions>
                <v-card-text>
                  <v-client-table ref="vuetable_saldos" :data="datos2" :columns="columns2" :options="options2" class="elevation-1 pa-2" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontró ningun registro</v-alert>
                    </template>

                    <template slot="abonos" slot-scope="props">
                      <div style="text-align:right">{{ formatNumberDec(parseFloat(props.row["abonos"]).toFixed(2),2) }}</div>
                    </template>
                    <template slot="saldo" slot-scope="props">
                      <div style="text-align:right">{{ formatNumberDec(parseFloat(props.row["saldo"]).toFixed(2),2) }}</div>
                    </template>
                    <template slot="beforeTable">
                      <div class="table-responsive" style="width:100%; justify-content:space-around; display:flex;, margin:5px !important; padding: 15px !important;">
                        <div class="">
                        </div>
                        <v-spacer></v-spacer>
                        <div style="text-align: right;">
                          <span ><b>Total Saldos:</b> {{to_currency_decimal(ts)}}</span>
                        </div>
                      </div>
                    </template>
                  </v-client-table>
                </v-card-text>
            </v-tab-item>
          </v-tabs>

        </base-material-card>
      </v-col>
    </v-row>
    <input type="hidden" :data="datafiltered3">
    <LoaderFraces ref="estadoLoader" :mensajes="lista_mensajes" ></LoaderFraces>
  </v-container>

  <v-dialog v-model="dialog1" max-width="500px" >
    <v-card>
      <v-card-text>
        <h5>Ingrese lista de Fracciones</h5>
        <span>Uno por línea</span>
        <v-form ref="formListadoFracciones" lazy-validation="" >
          <v-textarea outlined rows="15" v-model="listado" :rules="[validaListadoFracciones]" ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="listado=''; dialog1 = false" >Cancelar</v-btn>
        <v-btn small color="primary" @click="agregar_fracciones" >Buscar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="dialog2" max-width="500px" >
    <v-card>
      <v-card-text>
        <h5>Ingrese lista de Palabras Clave</h5>
        <span>Uno por línea</span>
        <v-form ref="formListadoFracciones" lazy-validation="" >
          <v-textarea outlined rows="15" v-model="listado" :rules="[validaListadoPalabras]" ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="listado=''; dialog2 = false" >Cancelar</v-btn>
        <v-btn small color="primary" @click="agregar_palabras" >Buscar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import RefreshButton from "@/components/RefreshButton.vue";
import LoaderFraces from "@/components/LoaderFraces";

export default {
  components: {
    LoaderFraces,
    "v-refresh-button": RefreshButton,
  },
  created: async function() {
    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
      this.permisoEliminar = true;
    }
    this.loading = false;
    this.tipo = 1;
    this.model.rfc = this.$local_storage.get("rfc");
    this.model.usuario = this.$local_storage.get("id_usuario");
    this.model2.rfc = this.$local_storage.get("rfc");
    this.model2.usuario = this.$local_storage.get("id_usuario");
    await this.getFracciones();
  },
  data: () => ({
    dialog1: false,
    dialog2: false,
    listado:'',
    tipo_reporte:1,
    tipos:[
      {"id":1, "text": "Selección de Fracción"},
      {"id":2, "text": "Listado de Fracciones"},
      {"id":3, "text": "Listado de Palabras Clave"}
    ],
    ts:0,
    lista_mensajes: [
        "AGRADECEMOS SU PACIENCIA..",
        "ESTAMOS PROCESANDO LOS CARGOS..",
        "VERIFICANDO IDENTIFICADORES..",
        "VALIDACIÓN DE FORMAS DE PAGO..",
        "PROCESANDO ABONOS A LA FECHA..",
        "VERIFICANDO FRACCIONES..",
        "VALIDANDO CUENTAS POR IDENTIFICADOR DE ACTIVO..",
        "ANALIZANDO SOBREDESCARGO..",
        "GESTIONANDO SALDOS POR FRACCIÓN..",
        "TOTALIZANDO VALOR COMERCIAL PENDIENTE DE RETORNO..",
        "TOTALIZANDO CRÉDITO FISCAL.."
    ],
    consultado1: false,
    datafiltered1:[],
    consultado2: false,
    datafiltered2: [],
    campos_excel_periodos: {
      'Periodo Inicial': 'fecha_de',
      'Periodo Final': 'fecha_a',
      "Fraccion": "fraccion",
      'Descripcion': 'descripciones',
    },
    campos_excel_saldos: {
      'Periodo Inicial': 'fecha_de',
      'Periodo Final': 'fecha_a',
      "Fraccion": "fraccion",
      'Identificador': 'identificador',
      "Saldo": "saldo",
      "Último Abono": "ultimo"
    },
    permisoEliminar:false,
    list_activos:[
        {"id":"N","text":"No"}, //No Activo Fijos
        {"id":"S","text":"Si"}, //Activo Fijo
        {"id":"","text":"Todos"}],
    fracciones: [],
    fab: false,
    rfc: '',
    tipo: '',
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Auditorías",
        disabled: true,
        to: ""
      },
      {
        text: "Periodos de Fracciones",
        disabled: true,
        to: ""
      }
    ],
    datos: [],
    reportes: [],
    columns: [
            "fecha_de",
            "fecha_a",
            "fraccion",
            "descripciones"
            ],
    options: {
      filterable: true,
      sortable: true,

      headings: {
        "fecha_de":"Periodo Inicial",
        "fecha_a": "Periodo Final",
        "fraccion":"Fracción",
        "descripciones":"Descripción"
      }
    },
    columns2: [
            "fecha_de",
            "fecha_a",
            "fraccion",
            "identificador",
            "saldo",
            "ultimo"
            ],
    options2: {
      filterable: true,
      sortable: true,

      headings: {
        "fecha_de": "Periodo Incial",
        "fecha_a": "Periodo Final",
        "fraccion": "Fracción",
        "identificador": "Identificador",
        "saldo": "Saldo",
        "ultimo": "Último Abono"
      }
    },
    datos2:[],
    loading: false,
    show_loading: true,
    listado:"",
    model: {
      rfc: "",
      usuario: "",
      fecha_de: "2015-01-01",
      fecha_a: moment().format('YYYY-MM-DD'),
      activo: "",
      fraccion:[],
      tipo: "PERIODOS_FRACCIONES",
      palabras:[]
    },
    model2: {
      rfc: "",
      usuario: "",
      fecha_cargo:"",
      fecha_abono:"",
      activo:"",
      opcion_reporte: 1,
    },
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    },
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false
  }),
  methods: {
    agregar_fracciones: function() {
      if (this.$refs.formListadoFracciones.validate() && this.model.nombre_reporte!="") {
        this.model.fraccion = this.removerLineasVacias(this.listado);
        this.listado = String('')
        this.dialog1 = false;
      }
    },
    agregar_palabras: function() {
      if (this.$refs.formListadoFracciones.validate() && this.model.nombre_reporte!="") {
        this.model.palabras = this.removerLineasVacias(this.listado);
        this.listado = String('')
        this.dialog2 = false;
      }
    },
    validaListadoFracciones: function() {
      var listadoSinEspacios = this.removerLineasVacias(this.listado);
      if (listadoSinEspacios.length == 0) {
        return "Ingrese al menos 1 fracción. Favor de verificar.";
      } else if (listadoSinEspacios.length > 25) {
        return "No se puede consultar mas de 25 Fracciones";
      } else {
        const pattern = /^[\d]{8}$/;
        for (var k in listadoSinEspacios) {
          if (!pattern.test(listadoSinEspacios[k])){
            return "Formato de Fracción Invalido";
          }
        }
      }
      return true;
    },
    validaListadoPalabras: function() {
      var listadoSinEspacios = this.removerLineasVacias(this.listado);
      if (listadoSinEspacios.length == 0) {
        return "Ingrese al menos 1 palabra clave. Favor de verificar.";
      } else if (listadoSinEspacios.length > 250) {
        return "No se puede consultar mas de 250 Palabras";
      }
      // else {
      //   for (var k in listadoSinEspacios) {
      //     if (listadoSinEspacios[k].includes(' ')){
      //       return "No se permiten palabras compuestas";
      //     }
      //   }
      // }
      return true;
    },
    removerLineasVacias(listado) {
      var listadoSplit = this.listado.split("\n");
      var listadoSinEspacios = listadoSplit.filter(item => {
        return item.trim() != "";
      });
      return listadoSinEspacios;
    },
    validaDiasPreview: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
        if (Math.abs(diferencia) > 31)
          return "Periodo máximo de consulta 31 dias. Favor de verificar."
      }
      return true;
    },
    validaDias: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
        if (Math.abs(diferencia) > 366)
          return "Periodo máximo de reporte 365 días. Favor de verificar."
      }
      return true;
    },
    validaFecha: function(fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida."
      else
        return true;
    },
    validaAnio: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
      }
      return true;
    },
    validaFracciones: function() {
      if(this.model.fraccion.length > 5) {
        this.$swal({
          type: "info",
          title: "¡Advertencia!",
          text: "Solo puedes seleccionar máximo 5 fracciones.",
          footer: ""
        });
        this.model.fraccion.pop();
        return "Máximo 5 fracciones";
      }

      return true;
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },
    getFracciones:async function(){
       this.$root.$dialogLoader.show('Espere un momento por favor..');
        var data = {
            "identificador": this.model.activo, //identificador de activo fijo N -> No, S -> Si, "" -> Todos
            "rfc": this.model.rfc
        };

        await axios({
            method: "post",
            url: this.$apiSA31 + "soluciona31/reportes/get_fracciones_inventario/",
            data: data
          })
          .then(response => {
                if(response.data && response.data.length){
                    this.fracciones = response.data
                } else {
                    this.fracciones = [];
                }
          }).catch(error => {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al obtener las fracciones. Intente nuevamente.",
              footer: ""
            });
          }).then(() => {
            this.$root.$dialogLoader.hide();
          });
    },
    generar_consulta() {
      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {
        this.consultado1 = false;
        this.$refs.estadoLoader.show('ESPERE UN MOMENTO POR FAVOR..');

        this.datos = [];
        var data = JSON.parse(JSON.stringify(this.model));
        data['id_reporte'] = 0;
        //return false;

        axios({
            method: "post",
            url: this.$apiSA31 + "soluciona31/reportes/fracciones_periodos/",
            data: data
          })
          .then(response => {
            this.consultado1 = true;
            this.datos = response.data;
          })
          .catch(error => {
            var mensaje = "";
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
            }
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al generar la consulta",
              footer: mensaje
            });
          }).then(() => {
            this.$refs.estadoLoader.hide();
          });
      }
    },
    generar_consulta_saldos() {
      if (!this.$refs.form2.validate()) {
        //Alguna operación o mensaje
      } else {
        this.consultado2 = false;
        this.$refs.estadoLoader.show('ESPERE UN MOMENTO POR FAVOR..');

        this.datos2 = [];
        var data = JSON.parse(JSON.stringify(this.model2));
        data['id_reporte'] = 0;
        //return false;
        var url = this.$apiSA31 + "soluciona31/reportes/fracciones_saldos_pendientes/";
        var url_test = "http://localhost:8000/soluciona31/reportes/fracciones_saldos_pendientes/"
        axios({
            method: "post",
            url: url,
            data: data
          })
          .then(response => {
            this.consultado2 = true;
            this.datos2 = response.data;
            this.datos2.forEach((it) => {
              this.total_saldo += it.saldo;
            });

          })
          .catch(error => {
            var mensaje = "";
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
            }
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al generar la consulta",
              footer: mensaje
            });
          }).then(() => {
            this.$refs.estadoLoader.hide();
          });
      }
    },
    filtrar_data_periodos: function(){
      if (this.$refs.vuetable_periodos != null) {
          this.datafiltered1 = this.$refs.vuetable_periodos.allFilteredData;
      } else {
          this.datafiltered1 = this.data;
      }
    },
    filtrar_data_saldos: function(){
      if (this.$refs.vuetable_saldos != null) {
          this.datafiltered2 = this.$refs.vuetable_saldos.allFilteredData;
      } else {
          this.datafiltered2 = this.data;
      }
    },
    formatNumberDec: function(numero, decimales){
      if (numero == undefined || numero == null || numero == "")
        return "";
      numero = Number(numero);
      if (isNaN(numero)){
        return "";
      } else
        return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },
    to_currency_decimal: function(x) {
      let cr = 'USD';

      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: cr,
        minimumFractionDigits: 2,
      })

      return formatter.format(x);
    },
  },
  computed: {
    datafiltered3() {
      this.ts = 0;
      let self = this;
      let result = [];
      if (self.$refs.vuetable_saldos != null) {
        console.log("si entra");
        result = this.$refs.vuetable_saldos.allFilteredData;
        result.forEach((it) => {
          this.ts +=it.saldo;
        });

        return result;
      } else {
        console.log("no entra");
        result = this.datos2;
        result.forEach((it) => {
          this.ts +=it.saldo;
        });

        return result;
      }
    }

  },
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}
</style>
